import React from 'react';
import { MenuLogoIcon } from '../appearence/icons/small_logo_icon';
import { BurgerIcon } from '../appearence/icons/burger_icon';

const Header = ({ setMenuIsOpen, menuIsOpen }) => {
    return (
        <header className="header flex items-center justify-between bg-white px-28 py-20">
            <MenuLogoIcon nameOfClass="header__logo h-80 w-80" />
            <BurgerIcon nameOfClass="header__menu h-32 w-32" handleClick={setMenuIsOpen} value={!menuIsOpen} />
        </header>
    );
};

export default Header;
